(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    function tidySeibertronFooterText() {
      var footer = document.querySelector(".seibertron-footer");
      if (!footer) {
        return;
      }

      footer.querySelectorAll(".seibertron-footer__brand-name").forEach(function (brand) {
        if ((brand.textContent || "").trim() !== "Seibertron") {
          brand.textContent = "Seibertron";
        }
        brand.classList.add("notranslate");
        brand.setAttribute("translate", "no");
      });

      footer.querySelectorAll(".seibertron-footer__brand").forEach(function (brandBlock) {
        brandBlock.classList.add("notranslate");
        brandBlock.setAttribute("translate", "no");
      });

      var labelMap = {
        "about us": "About Us",
        "blog": "Blog",
        "my account": "My Account",
        "track your order": "Track Your Order",
        "privacy policy": "Privacy Policy",
        "shipping policy": "Shipping Policy",
        "delivery policy": "Delivery Policy",
        "returns and refunds": "Returns And Refunds",
        "wearing and care guide": "Wearing And Care Guide",
        "affiliate program": "Affiliate Program",
        "contact us": "Contact Us"
      };

      var pathLabelMap = {
        "/": "Home",
        "/search": "Search",
        "/collections": "Collections",
        "/collections/all": "Shop All",
        "/policies/privacy-policy": "Privacy Policy",
        "/pages/privacy-policy-new": "Privacy Policy"
      };

      footer.querySelectorAll(".footer-block__details-content a").forEach(function (link) {
        var key = (link.textContent || "").replace(/\s+/g, " ").trim().toLowerCase();
        var path = "";
        try {
          path = new URL(link.href, window.location.origin).pathname.replace(/\/$/, "") || "/";
        } catch (error) {
          path = "";
        }
        var englishLabel = pathLabelMap[path] || labelMap[key];
        if (englishLabel) {
          if ((link.textContent || "").trim() !== englishLabel) {
            link.textContent = englishLabel;
          }
        }
      });
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", tidySeibertronFooterText);
    } else {
      tidySeibertronFooterText();
    }

    [250, 800, 1600, 3200].forEach(function (delay) {
      window.setTimeout(tidySeibertronFooterText, delay);
    });

    var footerObserver = new MutationObserver(function () {
      window.requestAnimationFrame(tidySeibertronFooterText);
    });

    window.setTimeout(function () {
      var footer = document.querySelector(".seibertron-footer");
      if (footer) {
        footerObserver.observe(footer, { childList: true, subtree: true, characterData: true });
      }
    }, 500);
  })();

  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-solag-redesign-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const applySolagCacheBridge = () => {
      const section = document.querySelector('.solag-product');
      if (!section || document.documentElement.dataset.solagCacheBridge === 'ready') return;
      document.documentElement.dataset.solagCacheBridge = 'ready';

      if (!document.querySelector('link[href*="solag-product-redesign.css"]')) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = '/cdn/shop/t/1/assets/solag-product-redesign.css';
        document.head.appendChild(link);
      }

      if (!document.querySelector('style[data-solag-cache-bridge]')) {
        const style = document.createElement('style');
        style.dataset.solagCacheBridge = 'true';
        style.textContent = '.solag-product{background:#f6f5f2;color:#15171a;font-family:Inter,"Helvetica Neue",Arial,sans-serif}.solag-product__panel,.solag-product__detail-card,.solag-product__trust-card{background:#fff;color:#15171a}.solag-product h1{color:#101214}.solag-product__summary,.solag-product__detail-card p,.solag-product__trust-card p{color:#3f454c}.solag-product__choice{border-color:#c8ced6;color:#15171a;background:#fff}.solag-product__swatch{color:#fff!important;border:2px solid rgba(255,255,255,.9)!important;box-shadow:0 8px 20px rgba(17,20,24,.16)}.solag-product__choice.is-selected{outline:3px solid rgba(191,42,42,.2);border-color:#bf2a2a}.solag-product__add{background:#bf2a2a;color:#fff}.solag-product__add:hover{background:#9f2020}';
        document.head.appendChild(style);
      }

      const swatchColors = {
        grey: '#727a7a',
        gray: '#727a7a',
        'army-green': '#46513a',
        coyote: '#986f46',
        black: '#101214'
      };
      const toHandle = (value) => value.toLowerCase().trim().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

      section.querySelectorAll('.solag-product__swatch').forEach((swatch) => {
        const input = swatch.querySelector('[data-solag-option]');
        const value = input ? input.value : swatch.textContent;
        const color = swatchColors[toHandle(value || '')];
        if (color) swatch.style.background = color;
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applySolagCacheBridge);
    } else {
      applySolagCacheBridge();
    }
  })();

  document.querySelectorAll('.solag-product__form').forEach((form) => {
    const section = form.closest('.solag-product');
    const variantScript = section.querySelector('[data-solag-variants]');
    const variantMediaScript = section.querySelector('[data-solag-variant-media]');
    const variants = variantScript ? JSON.parse(variantScript.textContent) : [];
    const variantMedia = variantMediaScript ? JSON.parse(variantMediaScript.textContent) : [];
    const mediaByVariantId = new Map(variantMedia.map((item) => [String(item.id), item.image]).filter((item) => item[1]));
    const idInput = form.querySelector('[data-solag-variant-id]');
    const addButton = form.querySelector('[data-solag-add]');
    const price = section.querySelector('[data-solag-price]');
    const moneyFormat = section.dataset.moneyFormat;
    const mainMedia = section.querySelector('.solag-product__main-media');

    const formatMoney = (cents) => {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
    };

    const sizedImageUrl = (url, width) => {
      if (!url) return '';
      try {
        const parsed = new URL(url, window.location.origin);
        parsed.searchParams.set('width', width);
        return parsed.toString();
      } catch (error) {
        return url;
      }
    };

    const normalizeImageKey = (url) => {
      if (!url) return '';
      try {
        const parsed = new URL(url, window.location.origin);
        return parsed.pathname.split('/').pop();
      } catch (error) {
        return String(url).split('?')[0].split('/').pop();
      }
    };

    const syncActiveThumbnail = (src) => {
      const targetKey = normalizeImageKey(src);
      const buttons = section.querySelectorAll('[data-solag-media-button]');
      let matched = false;
      buttons.forEach((button) => {
        const buttonKey = normalizeImageKey(button.dataset.mediaSrc || (button.querySelector('img') || {}).src || '');
        const isMatch = targetKey && buttonKey === targetKey;
        button.classList.toggle('is-active', isMatch);
        if (isMatch) {
          matched = true;
          if (typeof button.scrollIntoView === 'function') {
            button.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          }
        }
      });
      if (!matched) buttons.forEach((button) => button.classList.remove('is-active'));
    };

    const setMainMedia = (media) => {
      if (!mainMedia || !media || !media.src) return;
      mainMedia.src = sizedImageUrl(media.src, 1200);
      mainMedia.srcset = [500, 700, 900, 1200].map((width) => `${sizedImageUrl(media.src, width)} ${width}w`).join(', ');
      if (media.alt) mainMedia.alt = media.alt;
      syncActiveThumbnail(media.src);
    };

    const selectedOptions = () => {
      return Array.from(form.querySelectorAll('[data-solag-option-index]')).map((group) => {
        const checked = group.querySelector('[data-solag-option]:checked');
        return checked ? checked.value : '';
      });
    };

    const updateVariant = () => {
      const selected = selectedOptions();
      const variant = variants.find((item) => {
        return item.options.every((option, index) => option === selected[index]);
      });
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (price) price.textContent = formatMoney(variant.price);
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? addButton.dataset.availableText || addButton.textContent : addButton.dataset.soldOutText || addButton.textContent;
      }
      setMainMedia(mediaByVariantId.get(String(variant.id)));
    };

    form.querySelectorAll('[data-solag-option]').forEach((input) => {
      input.addEventListener('change', () => {
        const fieldset = input.closest('[data-solag-option-index]');
        const selected = fieldset ? fieldset.querySelector('[data-solag-selected-option]') : null;
        if (fieldset) {
          fieldset.querySelectorAll('.solag-product__choice').forEach((choice) => choice.classList.remove('is-selected'));
          input.closest('.solag-product__choice').classList.add('is-selected');
        }
        if (selected) selected.textContent = input.value;
        updateVariant();
      });
    });
    updateVariant();
  });

  document.querySelectorAll('[data-solag-media-button]').forEach((button) => {
    button.addEventListener('click', () => {
      const gallery = button.closest('.solag-product__gallery');
      const main = gallery ? gallery.querySelector('.solag-product__main-media') : null;
      const image = button.querySelector('img');
      if (!main || !image) return;
      main.src = button.dataset.mediaSrc || image.src.replace('width=160', 'width=1200');
      main.srcset = '';
      if (button.dataset.mediaAlt) main.alt = button.dataset.mediaAlt;
      gallery.querySelectorAll('[data-solag-media-button]').forEach((item) => item.classList.remove('is-active'));
      button.classList.add('is-active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-solag-redesign-v3"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.solag-product__form').forEach((form) => {
    const section = form.closest('.solag-product');
    const variantScript = section.querySelector('[data-solag-variants]');
    const variantMediaScript = section.querySelector('[data-solag-variant-media]');
    const variants = variantScript ? JSON.parse(variantScript.textContent) : [];
    const variantMedia = variantMediaScript ? JSON.parse(variantMediaScript.textContent) : [];
    const mediaByVariantId = new Map(variantMedia.map((item) => [String(item.id), item.image]).filter((item) => item[1]));
    const idInput = form.querySelector('[data-solag-variant-id]');
    const addButton = form.querySelector('[data-solag-add]');
    const price = section.querySelector('[data-solag-price]');
    const moneyFormat = section.dataset.moneyFormat;
    const mainMedia = section.querySelector('.solag-product__main-media');
    let activeColor = '';

    const formatMoney = (cents) => {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
    };

    const sizedImageUrl = (url, width) => {
      if (!url) return '';
      try {
        const parsed = new URL(url, window.location.origin);
        parsed.searchParams.set('width', width);
        return parsed.toString();
      } catch (error) {
        return url;
      }
    };

    const normalizeImageKey = (url) => {
      if (!url) return '';
      try {
        const parsed = new URL(url, window.location.origin);
        return parsed.pathname.split('/').pop();
      } catch (error) {
        return String(url).split('?')[0].split('/').pop();
      }
    };

    const normalizeColor = (value) => String(value || '').trim().toLowerCase().replace(/[_-]+/g, ' ').replace(/\s+/g, ' ');

    const colorFromOptionValue = (value) => {
      const normalized = normalizeColor(value);
      if (normalized.includes('army green')) return 'army green';
      if (normalized.includes('coyote')) return 'coyote';
      if (normalized.includes('black')) return 'black';
      if (normalized.includes('grey')) return 'grey';
      if (normalized.includes('gray')) return 'grey';
      return normalized;
    };

    const colorTagFrom = (text) => {
      const match = String(text || '').match(/\bcolor\s*:\s*([^,;|\n\r]+)/i);

      // Images without a color marker stay visible as shared images.
      return match ? normalizeColor(match[1]) : 'all';
    };

    const selectedColor = () => {
      const colorGroup = Array.from(form.querySelectorAll('[data-solag-option-index]')).find((group) => {
        const name = normalizeColor(group.dataset.solagOptionName);
        if (name === 'color' || name === 'colour') return true;
        if (name.includes('style')) {
          const checked = group.querySelector('[data-solag-option]:checked');
          return checked && colorFromOptionValue(checked.value) !== normalizeColor(checked.value);
        }
        return false;
      });
      const checked = colorGroup ? colorGroup.querySelector('[data-solag-option]:checked') : null;
      return checked ? colorFromOptionValue(checked.value) : '';
    };

    const buttonMatchesColor = (button, color) => {
      const normalizedColor = normalizeColor(color);
      const mediaColor = colorTagFrom(button.dataset.colorTags || button.dataset.mediaAlt || '');
      return !normalizedColor || mediaColor === 'all' || mediaColor === normalizedColor;
    };

    const setButtonVisibility = (button, isVisible) => {
      button.hidden = !isVisible;
      button.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
    };

    const filterMediaByColor = (color, preferredMedia) => {
      const buttons = Array.from(section.querySelectorAll('[data-solag-media-button]'));
      if (!buttons.length) return;

      let visibleButtons = buttons.filter((button) => buttonMatchesColor(button, color));
      if (!visibleButtons.length) visibleButtons = buttons;

      buttons.forEach((button) => setButtonVisibility(button, visibleButtons.includes(button)));

      const preferredKey = preferredMedia && preferredMedia.src ? normalizeImageKey(preferredMedia.src) : '';
      const preferredButton = preferredKey ? visibleButtons.find((button) => normalizeImageKey(button.dataset.mediaSrc || '') === preferredKey) : null;
      const activeButton = visibleButtons.find((button) => button.classList.contains('is-active'));
      const targetButton = preferredButton || activeButton || visibleButtons[0];
      const image = targetButton ? targetButton.querySelector('img') : null;

      if (targetButton) {
        setMainMedia({
          src: targetButton.dataset.mediaSrc || (image ? image.src : ''),
          alt: targetButton.dataset.mediaAlt || (image ? image.alt : '')
        });
      }
    };

    const syncActiveThumbnail = (src) => {
      const targetKey = normalizeImageKey(src);
      const buttons = section.querySelectorAll('[data-solag-media-button]');
      let matched = false;
      buttons.forEach((button) => {
        const buttonKey = normalizeImageKey(button.dataset.mediaSrc || (button.querySelector('img') || {}).src || '');
        const isMatch = targetKey && buttonKey === targetKey;
        button.classList.toggle('is-active', isMatch);
        if (isMatch) {
          matched = true;
          if (typeof button.scrollIntoView === 'function') {
            button.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          }
        }
      });
      if (!matched) buttons.forEach((button) => button.classList.remove('is-active'));
    };

    const setMainMedia = (media) => {
      if (!mainMedia || !media || !media.src) return;
      mainMedia.src = sizedImageUrl(media.src, 1200);
      mainMedia.srcset = [500, 700, 900, 1200].map((width) => `${sizedImageUrl(media.src, width)} ${width}w`).join(', ');
      if (media.alt) mainMedia.alt = media.alt;
      syncActiveThumbnail(media.src);
    };

    const selectedOptions = () => {
      return Array.from(form.querySelectorAll('[data-solag-option-index]')).map((group) => {
        const checked = group.querySelector('[data-solag-option]:checked');
        return checked ? checked.value : '';
      });
    };

    const updateVariant = () => {
      const selected = selectedOptions();
      const variant = variants.find((item) => {
        return item.options.every((option, index) => option === selected[index]);
      });
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (price) price.textContent = formatMoney(variant.price);
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? addButton.dataset.availableText || addButton.textContent : addButton.dataset.soldOutText || addButton.textContent;
      }
      const nextColor = normalizeColor(selectedColor());
      const colorChanged = nextColor && nextColor !== activeColor;
      const variantMedia = mediaByVariantId.get(String(variant.id));
      filterMediaByColor(nextColor, colorChanged || !nextColor ? variantMedia : null);
      activeColor = nextColor;
    };

    form.querySelectorAll('[data-solag-option]').forEach((input) => {
      input.addEventListener('change', () => {
        const fieldset = input.closest('[data-solag-option-index]');
        const selected = fieldset ? fieldset.querySelector('[data-solag-selected-option]') : null;
        if (fieldset) {
          fieldset.querySelectorAll('.solag-product__choice').forEach((choice) => choice.classList.remove('is-selected'));
          input.closest('.solag-product__choice').classList.add('is-selected');
        }
        if (selected) selected.textContent = input.value;
        updateVariant();
      });
    });
    updateVariant();
  });

  document.querySelectorAll('[data-solag-media-button]').forEach((button) => {
    button.addEventListener('click', () => {
      if (button.hidden) return;
      const gallery = button.closest('.solag-product__gallery');
      const main = gallery ? gallery.querySelector('.solag-product__main-media') : null;
      const image = button.querySelector('img');
      if (!main || !image) return;
      main.src = button.dataset.mediaSrc || image.src.replace('width=160', 'width=1200');
      main.srcset = '';
      if (button.dataset.mediaAlt) main.alt = button.dataset.mediaAlt;
      gallery.querySelectorAll('[data-solag-media-button]').forEach((item) => item.classList.remove('is-active'));
      button.classList.add('is-active');
    });
  });

  class SolagRelatedProducts extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded === 'true') return;
      this.dataset.loaded = 'true';
      const url = this.dataset.url;
      if (!url) return;

      fetch(url, { credentials: 'same-origin' })
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const related = html.querySelector('solag-related-products');
          const grid = related ? related.querySelector('.product-grid') : null;

          if (grid) {
            this.innerHTML = grid.outerHTML;
            this.classList.add('is-loaded');
          } else {
            this.innerHTML = '<p class="solag-product__related-loading">No related products available.</p>';
          }
        })
        .catch(() => {
          this.innerHTML = '<p class="solag-product__related-loading">No related products available.</p>';
        });
    }
  }

  if (!customElements.get('solag-related-products')) {
    customElements.define('solag-related-products', SolagRelatedProducts);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-solag-redesign"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const applySolagCacheBridge = () => {
      const section = document.querySelector('.solag-product');
      if (!section || document.documentElement.dataset.solagCacheBridge === 'ready') return;
      document.documentElement.dataset.solagCacheBridge = 'ready';

      if (!document.querySelector('link[href*="solag-product-redesign.css"]')) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = '/cdn/shop/t/1/assets/solag-product-redesign.css';
        document.head.appendChild(link);
      }

      if (!document.querySelector('style[data-solag-cache-bridge]')) {
        const style = document.createElement('style');
        style.dataset.solagCacheBridge = 'true';
        style.textContent = '.solag-product{background:#f6f5f2;color:#15171a;font-family:Inter,"Helvetica Neue",Arial,sans-serif}.solag-product__panel,.solag-product__detail-card,.solag-product__trust-card{background:#fff;color:#15171a}.solag-product h1{color:#101214}.solag-product__summary,.solag-product__detail-card p,.solag-product__trust-card p{color:#3f454c}.solag-product__choice{border-color:#c8ced6;color:#15171a;background:#fff}.solag-product__swatch{color:#fff!important;border:2px solid rgba(255,255,255,.9)!important;box-shadow:0 8px 20px rgba(17,20,24,.16)}.solag-product__choice.is-selected{outline:3px solid rgba(191,42,42,.2);border-color:#bf2a2a}.solag-product__add{background:#bf2a2a;color:#fff}.solag-product__add:hover{background:#9f2020}';
        document.head.appendChild(style);
      }

      const swatchColors = {
        grey: '#727a7a',
        gray: '#727a7a',
        'army-green': '#46513a',
        coyote: '#986f46',
        black: '#101214'
      };
      const toHandle = (value) => value.toLowerCase().trim().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

      section.querySelectorAll('.solag-product__swatch').forEach((swatch) => {
        const input = swatch.querySelector('[data-solag-option]');
        const value = input ? input.value : swatch.textContent;
        const color = swatchColors[toHandle(value || '')];
        if (color) swatch.style.background = color;
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applySolagCacheBridge);
    } else {
      applySolagCacheBridge();
    }
  })();

  document.querySelectorAll('.solag-product__form').forEach((form) => {
    const section = form.closest('.solag-product');
    const variantScript = section.querySelector('[data-solag-variants]');
    const variantMediaScript = section.querySelector('[data-solag-variant-media]');
    const variants = variantScript ? JSON.parse(variantScript.textContent) : [];
    const variantMedia = variantMediaScript ? JSON.parse(variantMediaScript.textContent) : [];
    const mediaByVariantId = new Map(variantMedia.map((item) => [String(item.id), item.image]).filter((item) => item[1]));
    const idInput = form.querySelector('[data-solag-variant-id]');
    const addButton = form.querySelector('[data-solag-add]');
    const price = section.querySelector('[data-solag-price]');
    const moneyFormat = section.dataset.moneyFormat;
    const mainMedia = section.querySelector('.solag-product__main-media');

    const formatMoney = (cents) => {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
    };

    const sizedImageUrl = (url, width) => {
      if (!url) return '';
      try {
        const parsed = new URL(url, window.location.origin);
        parsed.searchParams.set('width', width);
        return parsed.toString();
      } catch (error) {
        return url;
      }
    };

    const normalizeImageKey = (url) => {
      if (!url) return '';
      try {
        const parsed = new URL(url, window.location.origin);
        return parsed.pathname.split('/').pop();
      } catch (error) {
        return String(url).split('?')[0].split('/').pop();
      }
    };

    const syncActiveThumbnail = (src) => {
      const targetKey = normalizeImageKey(src);
      const buttons = section.querySelectorAll('[data-solag-media-button]');
      let matched = false;
      buttons.forEach((button) => {
        const buttonKey = normalizeImageKey(button.dataset.mediaSrc || (button.querySelector('img') || {}).src || '');
        const isMatch = targetKey && buttonKey === targetKey;
        button.classList.toggle('is-active', isMatch);
        if (isMatch) {
          matched = true;
          if (typeof button.scrollIntoView === 'function') {
            button.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          }
        }
      });
      if (!matched) buttons.forEach((button) => button.classList.remove('is-active'));
    };

    const setMainMedia = (media) => {
      if (!mainMedia || !media || !media.src) return;
      mainMedia.src = sizedImageUrl(media.src, 1200);
      mainMedia.srcset = [500, 700, 900, 1200].map((width) => `${sizedImageUrl(media.src, width)} ${width}w`).join(', ');
      if (media.alt) mainMedia.alt = media.alt;
      syncActiveThumbnail(media.src);
    };

    const selectedOptions = () => {
      return Array.from(form.querySelectorAll('[data-solag-option-index]')).map((group) => {
        const checked = group.querySelector('[data-solag-option]:checked');
        return checked ? checked.value : '';
      });
    };

    const updateVariant = () => {
      const selected = selectedOptions();
      const variant = variants.find((item) => {
        return item.options.every((option, index) => option === selected[index]);
      });
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (price) price.textContent = formatMoney(variant.price);
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? addButton.dataset.availableText || addButton.textContent : addButton.dataset.soldOutText || addButton.textContent;
      }
      setMainMedia(mediaByVariantId.get(String(variant.id)));
    };

    form.querySelectorAll('[data-solag-option]').forEach((input) => {
      input.addEventListener('change', () => {
        const fieldset = input.closest('[data-solag-option-index]');
        const selected = fieldset ? fieldset.querySelector('[data-solag-selected-option]') : null;
        if (fieldset) {
          fieldset.querySelectorAll('.solag-product__choice').forEach((choice) => choice.classList.remove('is-selected'));
          input.closest('.solag-product__choice').classList.add('is-selected');
        }
        if (selected) selected.textContent = input.value;
        updateVariant();
      });
    });
    updateVariant();
  });

  document.querySelectorAll('[data-solag-media-button]').forEach((button) => {
    button.addEventListener('click', () => {
      const gallery = button.closest('.solag-product__gallery');
      const main = gallery ? gallery.querySelector('.solag-product__main-media') : null;
      const image = button.querySelector('img');
      if (!main || !image) return;
      main.src = button.dataset.mediaSrc || image.src.replace('width=160', 'width=1200');
      main.srcset = '';
      if (button.dataset.mediaAlt) main.alt = button.dataset.mediaAlt;
      gallery.querySelectorAll('[data-solag-media-button]').forEach((item) => item.classList.remove('is-active'));
      button.classList.add('is-active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seibertron-home-redesign"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const thumbUrl = (source) => {
      try {
        const url = new URL(source, window.location.href);
        if (url.hostname.includes("cdn.shopify.com") || url.hostname.includes(window.location.hostname)) {
          url.searchParams.set("width", "72");
        }
        return url.toString();
      } catch (error) {
        return source;
      }
    };

    const renderDealThumbs = (card, sources) => {
      const imageWrap = card.querySelector(".seibertron-market__deal-image");
      if (!imageWrap || !sources.length) return;

      const uniqueSources = Array.from(new Set(sources.filter(Boolean))).slice(0, 12);
      if (!uniqueSources.length) return;

      const existing = card.querySelector(".seibertron-market__deal-thumbs");
      const thumbs = document.createElement("span");
      thumbs.className = "seibertron-market__deal-thumbs";
      thumbs.setAttribute("aria-label", "More product images");

      uniqueSources.slice(0, 6).forEach((source, index) => {
        const item = document.createElement("span");
        item.className = `seibertron-market__deal-thumb${index === 0 ? " is-active" : ""}`;
        item.setAttribute("aria-hidden", "true");

        const image = document.createElement("img");
        image.src = thumbUrl(source);
        image.alt = "";
        image.width = 32;
        image.height = 32;
        image.loading = "lazy";

        item.appendChild(image);
        thumbs.appendChild(item);
      });

      if (uniqueSources.length > 6) {
        const more = document.createElement("span");
        more.className = "seibertron-market__deal-more";
        more.textContent = `+${uniqueSources.length - 6}`;
        thumbs.appendChild(more);
      }

      if (existing) {
        existing.replaceWith(thumbs);
      } else {
        imageWrap.insertAdjacentElement("afterend", thumbs);
      }
    };

    const normalizeDealCardOrder = (card) => {
      const title = card.querySelector("strong");
      const rating = card.querySelector(".seibertron-market__deal-rating");
      if (!title || !rating) return;
      const children = Array.from(card.children);
      if (children.indexOf(title) > children.indexOf(rating)) {
        rating.before(title);
      }
    };

    const initDealCards = (scope = document) => {
      scope.querySelectorAll(".seibertron-market__deal-card").forEach((card) => {
        normalizeDealCardOrder(card);
        if (card.dataset.dealThumbsReady === "true") return;

        const mainImage = card.querySelector(".seibertron-market__deal-image img");
        if (!mainImage) return;

        const fallback = [mainImage.currentSrc || mainImage.src];
        renderDealThumbs(card, fallback);

        const href = card.getAttribute("href");
        if (!href || !href.includes("/products/")) {
          card.dataset.dealThumbsReady = "true";
          return;
        }

        card.dataset.dealThumbsReady = "true";

        const productUrl = new URL(href, window.location.href);
        productUrl.pathname = productUrl.pathname.replace(/\/$/, "") + ".js";
        productUrl.search = "";

        fetch(productUrl.toString(), { credentials: "same-origin" })
          .then((response) => (response.ok ? response.json() : null))
          .then((product) => {
            if (!product || !Array.isArray(product.images) || !product.images.length) return;
            const productImages = product.images
              .map((image) => (typeof image === "string" ? image : image && image.src))
              .filter(Boolean);
            if (productImages.length) renderDealThumbs(card, productImages);
          })
          .catch(() => {});
      });
    };

    const initStageCarousels = (scope = document) => {
      scope.querySelectorAll("[data-stage-carousel]").forEach((carousel) => {
        if (carousel.dataset.stageReady === "true") return;

        const slides = Array.from(carousel.querySelectorAll("[data-stage-slide]"));
        const dots = Array.from(carousel.querySelectorAll("[data-stage-dot]"));
        const prevButton = carousel.querySelector("[data-stage-prev]");
        const nextButton = carousel.querySelector("[data-stage-next]");
        const pauseButton = carousel.querySelector("[data-stage-pause]");

        if (slides.length < 2 || !prevButton || !nextButton) return;

        carousel.dataset.stageReady = "true";
        let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains("is-active")));
        let paused = false;
        let timer = null;

        const currentIndex = () => {
          const visibleIndex = slides.findIndex((slide) => slide.classList.contains("is-active"));
          return visibleIndex >= 0 ? visibleIndex : activeIndex;
        };

        const setSlide = (nextIndex) => {
          activeIndex = (nextIndex + slides.length) % slides.length;

          slides.forEach((slide, index) => {
            const isActive = index === activeIndex;
            slide.classList.toggle("is-active", isActive);
            if (isActive) {
              slide.removeAttribute("aria-hidden");
            } else {
              slide.setAttribute("aria-hidden", "true");
            }
          });

          dots.forEach((dot, index) => {
            const isActive = index === activeIndex;
            dot.classList.toggle("is-active", isActive);
            if (isActive) {
              dot.setAttribute("aria-current", "true");
            } else {
              dot.removeAttribute("aria-current");
            }
          });
        };

        const stopTimer = () => {
          if (timer) window.clearInterval(timer);
          timer = null;
        };

        const startTimer = () => {
          stopTimer();
          if (!paused) {
            timer = window.setInterval(() => setSlide(activeIndex + 1), 6500);
          }
        };

        prevButton.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          setSlide(currentIndex() - 1);
          startTimer();
        });

        nextButton.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          setSlide(currentIndex() + 1);
          startTimer();
        });

        dots.forEach((dot, index) => {
          dot.addEventListener("click", (event) => {
            event.preventDefault();
            event.stopPropagation();
            setSlide(index);
            startTimer();
          });
        });

        if (pauseButton) {
          pauseButton.addEventListener("click", (event) => {
            event.preventDefault();
            event.stopPropagation();
            paused = !paused;
            pauseButton.setAttribute("aria-pressed", paused ? "true" : "false");
            pauseButton.setAttribute("aria-label", paused ? "Resume banner rotation" : "Pause banner rotation");
            if (paused) {
              stopTimer();
            } else {
              startTimer();
            }
          });
        }

        carousel.addEventListener("mouseenter", stopTimer);
        carousel.addEventListener("mouseleave", startTimer);
        carousel.addEventListener("focusin", stopTimer);
        carousel.addEventListener("focusout", startTimer);

        setSlide(activeIndex);
        startTimer();
      });
    };

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => {
        initStageCarousels();
        initDealCards();
      });
    } else {
      initStageCarousels();
      initDealCards();
    }

    document.addEventListener("shopify:section:load", (event) => {
      initStageCarousels(event.target);
      initDealCards(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
